<template>
	<v-row justify="center">
		<v-dialog v-model="ui.dialog" persistent max-width="600">
			<v-card class="pa-4">
				<v-card-title>
					Vincular cliente
				</v-card-title>
				<v-card-text class="pb-0">
					<v-form
						ref="form"
						v-model="ui.valid"
						lazy-validation
						@submit.prevent="store()"
					>
						<v-row>
							<v-col cols="12" class="pb-0">
								<v-overflow-btn
									editable
									autocomplete="off"
									clearable
									dense
									outlined
									label="Cliente"
									:rules="[v.required]"
									:items="Customers"
									v-model="layout.customer_id"
								>
								</v-overflow-btn>
							</v-col>
						</v-row>
					</v-form>
				</v-card-text>
				<v-card-actions class="d-flex justify-end">
					<v-btn
						color="primary"
						text
						@click="ui.dialog = false"
						:disabled="ui.storing"
					>
						cancelar
					</v-btn>
					<v-btn
						color="primary"
						@click="store()"
						:loading="ui.storing"
						:disabled="!ui.valid"
					>
						enviar
					</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</v-row>
</template>

<script>
import axios from "axios";
import { V } from "@/main";
import { EventBus } from "@/main";
import { mapGetters } from "vuex";
import { mapState } from "vuex";

export default {
	props: ["pricelist"],

	data() {
		return {
			layout: { customer_id: null },

			v: V,

			ui: {
				valid: true,
				dialog: false,
				storing: false,
			},
		};
	},

	created() {
		EventBus.$on("PriceListCustomerAssociate", () => {
			this.ui.dialog = true;
		});

		this.$store.dispatch("getCustomers");
	},

	methods: {
		async store() {
			if (this.$refs.form.validate()) {
				try {
					this.ui.storing = true;

					let resp = await axios.post(
						`${process.env.VUE_APP_API_SERVER}/auth/pricelist/${this.pricelist.id}/customer`,
						this.layout,
						{
							headers: {
								Authorization: `Bearer ${this.acount.token}`,
							},
						}
					);

					EventBus.$emit(
						"PriceListCustomerAssociated",
						resp.data.data
					);

					this.$refs.form.reset();

					this.ui.dialog = false;
				} catch (error) {
					EventBus.$emit("Error", { error: error, errorsShow: true });
				} finally {
					this.ui.storing = false;
				}
			}
		},
	},

	computed: {
		...mapState(["acount"]),

		...mapGetters(["getCustomers"]),

		Customers() {
			return this.getCustomers.map((item) => {
				return {
					text: `${item.folio} - ${item.name}`,
					value: item.id,
				};
			});
		},
	},
};
</script>

<style lang="css" scoped></style>
